import { IRelatedArticleItem } from '@components/article/RelatedArticles/RelatedArticles.types';
import { FormatType } from '@consts/wysiwyg';

export const mergeRelatedArticleDataIntoContent = (
  content,
  relatedArticles: IRelatedArticleItem[],
  relatedArticlesCountInContent,
) => {
  const hasRelatedArticles = Boolean(relatedArticles.length);
  const hasRelatedArticlesInContent = relatedArticlesCountInContent !== 0;

  if (!hasRelatedArticles || !hasRelatedArticlesInContent) {
    return content;
  }

  let i = 0;
  return content.map((entry) => {
    if (entry.type === FormatType.relatedArticle) {
      const currentRelatedArticle = relatedArticles[i];
      i += 1;
      return {
        ...entry,
        relatedArticles: [currentRelatedArticle],
      };
    }

    return entry;
  });
};

export const countRelatedArticleInContent = (content) =>
  content.filter(({ type }) => type === FormatType.relatedArticle).length;
